var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 37.4999C0.75 51.7141 8.65869 64.0802 20.3152 70.4403V4.55957C8.65869 10.9196 0.75 23.2858 0.75 37.4999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4177 50.5434C74.925 46.4809 75.75 42.087 75.75 37.4999C75.75 32.9129 74.925 28.5188 73.4177 24.4565H3.08262C1.57515 28.5188 0.75 32.9129 0.75 37.4999C0.75 42.087 1.57515 46.4809 3.08262 50.5434L38.25 53.8042L73.4177 50.5434Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2499 75C54.3737 75 68.1189 64.8235 73.4176 50.5435H3.08252C8.38086 64.8235 22.1264 75 38.2499 75Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 37.4999C0.75 54.8259 12.5011 69.4049 28.4673 73.7081V1.29175C12.5011 5.59487 0.75 20.1739 0.75 37.4999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.692 16.5021L20.2333 13.0435L17.9277 15.3494L15.622 13.0435L12.1634 16.5021L14.4692 18.8079L12.1631 21.1139L15.6217 24.5725L17.9275 22.2666L20.2333 24.5725L23.692 21.1139L21.3862 18.8079L23.692 16.5021Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOman);
export default __webpack_public_path__ + "static/media/flagOman.f6a6b5ccfe36c73c97f5b75ab42788b3.svg";
export { ForwardRef as ReactComponent };